import { render, staticRenderFns } from "./BayModal.vue?vue&type=template&id=63617a98&scoped=true"
import script from "./BayModal.vue?vue&type=script&lang=js"
export * from "./BayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63617a98",
  null
  
)

export default component.exports